import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import { initSentry, Sentry } from "./sentry";

// Initialize Sentry before the first render so early errors are captured.
initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div
          style={{
            padding: 40,
            fontFamily: "system-ui, sans-serif",
            textAlign: "center",
          }}
        >
          <h1 style={{ color: "#dc2626" }}>Something went wrong</h1>
          <p style={{ color: "#64748b" }}>
            The error has been logged. Please refresh the page or try again.
          </p>
          <pre
            style={{
              background: "#f1f5f9",
              padding: 12,
              borderRadius: 6,
              fontSize: 12,
              maxWidth: 600,
              margin: "16px auto",
              overflow: "auto",
            }}
          >
            {error?.message || String(error)}
          </pre>
          <button
            onClick={resetError}
            style={{
              padding: "10px 20px",
              background: "#3b82f6",
              color: "white",
              border: "none",
              borderRadius: 6,
              cursor: "pointer",
            }}
          >
            Try Again
          </button>
        </div>
      )}
    >
      <AuthProvider>
        <App />
      </AuthProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
